<h1>Over ons</h1>

Mijn naam is Anniek van Dijk. Van jongs af aan heb ik al een passie gehad voor dieren. 
Van dieren wilde ik ooit mijn beroep maken. 
Daarom ben ik in Groningen en later in Leeuwarden Diermanagement gaan studeren. 
Na mijn studie ben ik niet meteen in de dieren gerold, maar in de ICT. 
Computers zijn ook een passie, dus waarom ook niet.
<p>
In 2007 ben ik mijn eerste bedrijf begonnen. 
Een ICT bedrijf gespecialiseerd in het testen van complexe zelfbouw 
software voor grote bedrijven (Animundo Software Testing Services).

<img src="/assets/images/pages/anniek_ikrit.png" alt="Anniek van Dijk">

Toen ik samen met mijn vriend Auke Wesselink op zoek ging naar een 
nieuw huis was het voor ons duidelijk, 
mijn eerste passie 'dieren' moet daar een plekje krijgen.
<p>
Het zouden schapen worden. Mini-schaapjes fokken leek me wel wat. 
Tijdens de zoektocht op internet naar schapen liep ik echter tegen de alpaca aan.
<p>
Nou, het 'alpacavirus' sloeg direct toe! Wat zijn het toch een leuke dieren om te zien. 
Ze hebben van die mooie grote ogen en een heerlijk zachte vacht. 
We zijn naar diverse alpacafokkers geweest om informatie te vergaren en workshops te volgen.  
<p>
In 2011 heb ik vier hoogwaardige fokmerries gekocht die uit Australië geïmporteerd zijn. 
En ik heb mijn tweede onderneming 'Alpacamundo' opgericht. 
<p>
Het leuke van het houden van alpaca's is dat het prima te combineren is met een vaste baan. 
En ik moet zeggen, de afwisseling tussen het kantoorwerk en het buiten werken met de dieren 
bevalt mij zeer goed. 
<p>
Mijn vriend is ook dol op dieren en viel ook meteen voor de alpaca, 
en helpt dagelijks mee in het bedrijf.   
<p>
<h2>Doelstellling</h2>
<ul>
  <li>
    Verbeteren van de wolkwaliteit, bouw en uitstraling binnen de eigen kudde, 
    evenals samenwerken met andere alpaca fokkers en opleidingsinstituten om 
    zo de europese alpacamarkt naar een hoger niveau te brengen.
  </li>
  <li>
    Bouw en uitstraling worden beïnvloed door persoonlijke smaak. 
    Onze smaak is: compacte dieren met een statig uiterlijk. 
    Met als grote voorbeeld de fantastisch mooie Australische hengst Jolimont Warrior.
  </li>
  <li>
    Wolkwaliteit is meetbaar. We streven bij de wol naar vachten die een comfortfactor van 100% hebben. 
    Geschikt voor kleding die op de huid gedragen kan worden zonder te kriebelen.
  </li>
  <li>
    Samenwerken met andere alpaca fokkers door onze kennis te delen en een bijdrage te leveren aan 
    diverse initiatieven op alpaca gebied. Bijvoorbeeld door het helpen bij Alpacashows in Noord Nederland.
  </li>
  <li>
    Samenwerken met onderwijsinstellingen op het gebied van dieren (dierverzorging t/m dierenartsen) 
    om jonge mensen kennis te laten maken met alles wat te maken heeft met de alpaca.
  </li>
</ul>
<p>
<h2>Gevolgde vakgerichte opleidingen, workshops, cursussen en andere bezigheden</h2>

<ul>
  <li>
    <a href="https://www.hvhl.nl/studeren/opleidingen/bachelor/Diermanagement?gclid=EAIaIQobChMIoNbxkdqd1wIVD50bCh2tMwHcEAAYASAAEgKWYfD_BwE" target="_blank">HBO Diermanagement</a>
  </li>
  <li>
    <a href="https://www.camelidynamics.com/" target="_blank">CameliDynamics</a>
  </li>
  <li>
    Organisatie alpaca keuringen in Noord Nederland (vanuit de Benelux Alpaca Vereniging <a href="http://www.alpaca-benelux.com/">AAB</a>)
  </li>
  <li>
    Diverse workshops wol skirten
  </li>
  <li>
    Diverse workshops wol analyse van alpaca wol
  </li>
  <li>
    Workshop bevallingen bij alpaca's
  </li>
  <li>
    Workshop mestonderzoek bij alpaca's
  </li>
  <li>
    Cursus en certificaat beroepsmatig veetransport
  </li> 
</ul>